import React from 'react';
import { AppBar, Toolbar } from '@mui/material';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';
import { useLayoutElements } from 'contexts/LayoutElementsContext/useLayoutElements';

interface TabletDesktopNavbarContainerProps {
  children: React.ReactNode;
  toolbarStyle?: React.CSSProperties;
}

export const TabletDesktopNavbarContainer = ({
  children,
  toolbarStyle,
}: TabletDesktopNavbarContainerProps) => {
  const { theme } = useThemeUtils();
  const { setAppBarRef } = useLayoutElements();

  return (
    <AppBar
      sx={{ backgroundColor: theme.palette.common.white }}
      position="sticky"
      aria-label="Application Header"
      ref={setAppBarRef}
    >
      <Toolbar disableGutters sx={{ ...toolbarStyle, minHeight: '62px' }}>
        {children}
      </Toolbar>
    </AppBar>
  );
};
